export const TABLE_CONFIG  = {
    wms: [
      { header: 'Device Name', field: 'dev_name' },
      { header: 'Sub Device Name', field: 'sub_device_name' },
      { header: 'Model', field: 'model_name' },
      { header: 'Name', field: 'name' },
      { header: 'Spec', field: 'spec' },
      { header: 'Slave Id', field: 'sub_device_id' },
      { header: 'Inverter Capacity', field: 'installed_capacity' },
      { header: 'Connected Solar Capacity', field: 'connected_solar_capacity' },
      { header: 'Sensor Name', field: 'sensorName' },
      { header: 'Param No', field: 'param_no' },
      { header: 'Gain', field: 'gain' },
      { header: 'Reminder', field: 'reminder' }
    ],
    normal: [
      { header: 'Device Name', field: 'dev_name' },
      { header: 'Sub Device', field: 'sub_device_name' },
       { header: 'Model Name', field: 'model_name' },
      { header: 'Name', field: 'name' },
      { header: 'Spec', field: 'spec' },
      { header: 'Slave Id', field: 'sub_device_id' },
      { header: 'Inverter Capacity', field: 'installed_capacity' },
      { header: 'Connected Solar Capacity', field: 'connected_solar_capacity' },
    ],


    ze: [
      { header: 'Device Name', field: 'dev_name' },
      { header: 'Sub Device Name', field: 'sub_device_name' },
      { header: 'Model Name', field: 'model_name' },
      { header: 'Name', field: 'name' },
      { header: 'Spec', field: 'spec' },
      { header: 'Slave Id', field: 'sub_device_id' },
      { header: 'Inverter Capacity', field: 'installed_capacity' },
      { header: 'Connected Solar Capacity', field: 'connected_solar_capacity' },
      { header: 'Sensor Name', field: 'sensorName' },
      { header: 'Param No', field: 'param_no' },
      { header: 'Gain', field: 'gain' },
      { header: 'Reminder', field: 'reminder' }

    ],

    dg: [
      { header: 'Device Name', field: 'dev_name' },
      { header: 'Sub Device Name', field: 'sub_device_name' },
      { header: 'Model Name', field: 'model_name' },
      { header: 'Name', field: 'name' },
      { header: 'DG Rating', field: 'dg_rating' },
      { header: 'Spec', field: 'spec' },
      { header: 'Slave Id', field: 'sub_device_id' },
      { header: 'Inverter Capacity', field: 'installed_capacity' },
      { header: 'Connected Solar Capacity', field: 'connected_solar_capacity' },
      { header: 'Sensor Name', field: 'sensorName' },
      { header: 'Param No', field: 'param_no' },
      { header: 'Gain', field: 'gain' },
      { header: 'Reminder', field: 'reminder' }
    ]
  };